import React, { useState, useEffect } from "react";
import Alert from '@material-ui/lab/Alert';
import { Transition } from 'react-transition-group';
import "./LoginMessageBox.scss";
const LoginMessageBox = (props) => {
    //const classes = useStyles();
    const defaultStyle = {
        transition: `opacity 50ms ease`,
        opacity: 1,
	  };
	const transitionStyles = {
		entering: {opacity: 0.50 }, 
		entered: {opacity: 1},
		exiting: { opacity: 0.50 },
		exited: { opacity: 0 }
	  };
	return (
        <Transition in={props.in} 
        timeout={{
            appear: 100,   
            enter: 100,
            exit: 100
        }} 
        appear 
        unmountOnExit >
            {state => (
       <div className="login-messagebox-container" style={{ ...defaultStyle, ...transitionStyles[state] }}>
                <Alert variant="filled" severity={props.type} >
                    {props.content}
                </Alert>
            </div>
            )}
        </Transition>
	);
};

export default LoginMessageBox;